import React from 'react';
import { styled } from '@mui/material/styles';
import AccessTimeRounded from '@mui/icons-material/AccessTimeRounded';
import Tooltip from '@mui/material/Tooltip';
import { momentFormat } from '#helper';

const RedTooltip = styled(Tooltip)({
  color: '#FF4635'
});

export default function TimeoutIcon(props) {
  const { timeoutAlert, account, iconProps } = props;

  const timestamp = timeoutAlert ?
    (timeoutAlert.lastMetric?.timestamp ?
      `${momentFormat(timeoutAlert.lastMetric?.timestamp, account, 'dateTimePartial')}` : 'No data') :
    null;

  return (
    timestamp ?
      <RedTooltip
        title={
          <div>
            {timestamp}
            <div>(more than 4 hours)</div>
          </div>
          }
        placement="right"
      >
        <AccessTimeRounded {...iconProps} />
      </RedTooltip> : null
  );
}
